import { fontFamily, dimensions, animation, deviceSize, deviceMediaQuery } from '../common';
import { typography } from './typography';
import { colors } from './colors';
import { styles } from './styles';
import { custom } from './custom';
export default { fontFamily, dimensions, typography, colors, styles, animation, custom, deviceSize, deviceMediaQuery };